"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardBrand = void 0;
var CardBrand;
(function (CardBrand) {
    CardBrand["Verve"] = "verve";
    CardBrand["Visa"] = "visa";
    CardBrand["Mastercard"] = "mastercard";
    CardBrand["Maestro"] = "maestro";
    CardBrand["AmericanExpress"] = "american-express";
    CardBrand["Jcb"] = "jcb";
    CardBrand["DinersClub"] = "diners-club";
    CardBrand["Discover"] = "discover";
    CardBrand["Aura"] = "aura";
    CardBrand["Elo"] = "elo";
    CardBrand["Hipercard"] = "hipercard";
    CardBrand["CartesBancaires"] = "cartes-bancaires";
})(CardBrand = exports.CardBrand || (exports.CardBrand = {}));
exports.default = CardBrand;
